import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

import { getErrorTypeFromTableNoDataType, getNoDataObject } from "../utils/utils";

import { EmptyStateStyled } from "./StyledComponents";

export const PerformanceWidgetContainer = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 25px 302px;
    box-sizing: border-box;
    padding: 0 24px;
    align-items: center;

    @media (max-width: 1280px) {
        grid-template-columns: 1fr 25px 271px;
    }

    @media (min-width: 1440px) {
        grid-template-columns: 1fr 25px 432px;
    }
`;

export const Divider = styled.div`
    height: 100%;
    width: 1px;
    background-color: ${colorsPalettes.carbon[100]};
`;

export const PerformanceEntitiesWidgetContainer = styled.div`
    padding: 16px 0;
`;

export const defaultMinHeight = 98;

export const getEmptyState = (
    isError?: boolean,
    hideImage?: boolean,
    minHeight?: number,
    noDataSubtitle: string = "ad.intelligence.overview.widget.empty.state.subtitle",
) => {
    const noDataObject = getNoDataObject(isError);

    return (
        <EmptyStateStyled
            title={noDataObject.title}
            subtitle={isError ? noDataObject.subtitle : translate(noDataSubtitle)}
            SvgImage={hideImage ? () => null : getErrorTypeFromTableNoDataType(noDataObject.type)}
            $gridSpan={1}
            $minHeight={minHeight}
        />
    );
};
